"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const note_1 = __importDefault(require("./note"));
const StreemshotNote = ({ onSave, disableEditing, streemshotId, noteText, roomId, }) => {
    const saveStreemshotNote = (note) => {
        onSave && onSave(note, roomId, streemshotId);
    };
    return ((0, jsx_runtime_1.jsx)(note_1.default, { placeholderText: "Add notes to streemshot", noteText: noteText, characterLimit: 225, onSave: saveStreemshotNote, disableEditing: disableEditing }));
};
exports.default = StreemshotNote;
//# sourceMappingURL=streemshot_note.js.map